'use strict'

# modules.exports = Groupon.loadSiteBlindado = ->

Groupon.loadSiteBlindado = ->
  script = document.createElement('script')
  script.setAttribute('async', '')
  document.body.appendChild(script).src = "//cdn.siteblindado.com/aw.js"



// WEBPACK FOOTER //
// ./core/frontend/groupon_modules/loadSiteBlindado.coffee